import { StepperStep } from "./parts/step";
import { StepperRoot } from "./stepper";

export type * from "./types-stepper";

/** Stepper composable (`Stepper.Root` + `Stepper.Step`): passos `done | active | pending`; horizontal (compacto no mobile), vertical com painel e cartões. */
export const Stepper = { Root: StepperRoot, Step: StepperStep };
